import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Search } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-dept-document-form',
  templateUrl: './dept-document-form.component.html',
  styleUrls: ['./dept-document-form.component.css']
})
export class DeptDocumentFormComponent implements OnInit {

  title = "Add Department Document"; 
 
  itemsPerPage: number=5;
  currentPage: number=1;
  DepartmentDocumentDetailsList : any = {};
  data : any = {};
  totalItems : number;
  s: Search;
  isSearch:boolean;
  dep_Id : number;
  DepartmentDetails : any = [];
  DepartmentDocumentdetails : any = {};  
  formInvalid: boolean; 
  dd : any = {};
  numericpattern = "^[0-9]*$";
  alphabetpattern = "^[a-zA-Z ]*$";
  alphanumpattern = "^[a-zA-Z0-9 ]*$";
  emailpattern = "^[a-zA-Z0-9._%-+]+@[a-z0-9.-]+\.[a-z]{2,3}$"; 
  
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
   }

  ngOnInit() {

    debugger;

    this.route.params.subscribe(params => {
      //  this.mode = params['mode'];
      this.dep_Id = params['dep_Id'];     
      this.GetDepartmentGridDetails(this.dep_Id);  
      // this.GetProceedingDetails(this.itemsPerPage, 1);  
      this.GetDepartmentDocumentDetails(this.itemsPerPage,1,this.dep_Id);  
      
    });


  }

  GetDepartmentGridDetails(dep_Id){
    debugger;
  document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetDepartmentGridDetails(dep_Id);
    this.data.subscribe(
      (response: any) => {       
        this.DepartmentDetails = response
        console.log('this.DepartmentDetails');
        console.log(this.DepartmentDetails);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  SaveDepartmentDocument(DepartmentDocument: NgForm){  
    debugger; 
  
    if(DepartmentDocument.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     
  
    else{                    
      DepartmentDocument.value.dep_Id = this.dep_Id ;      

    
      console.log(DepartmentDocument.value);
         
            this.data = this.userService.PostDepartmentDocument(DepartmentDocument.value);    
            this.data.subscribe(
            (response) => {
              DepartmentDocument.reset();
              DepartmentDocument.resetForm();
              DepartmentDocument.form.markAsPristine();
              DepartmentDocument.form.markAsUntouched();        
              swal('Success!', 'Department Document Added Successfully .', 'success');
              //this.router.navigate(['/home/investigation-doc/fir-prceeding']) ; 
              this.GetDepartmentDocumentDetails(this.itemsPerPage,1,this.dep_Id);    
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });       
           
    } 
  }

  
      //getting Proceeding
      GetDepartmentDocumentDetails(itemsPerPage:any,pageNo:any,dep_Id){
        debugger;
       
        this.isSearch = false;
          document.getElementById('loader-spinner').style.display = "block";
          this.data = this.userService.GetAllDepartmentDocumentDetails(itemsPerPage,pageNo,dep_Id);
          this.data.subscribe(
            (response: any) => {
              console.log(response);
              this.DepartmentDocumentdetails = response.DepartmentDocumentModel;
                this.totalItems = response.TotalItemsCount;
                this.itemsPerPage = itemsPerPage;
                this.currentPage = pageNo;  
              document.getElementById('loader-spinner').style.display = "none";
            },(error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });
        } 
        
        
        pageChanged(pageNumber: number) {
         // if (this.isSearch)
            //this.onSearch(this.s,this.itemsPerPage, pageNumber);
          //else
            this.GetDepartmentDocumentDetails(this.itemsPerPage, pageNumber,this.dep_Id);
        }
      
        itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
         // if (this.isSearch)
           // this.onSearch(this.s,this.itemsPerPage, pageNo);
         // else
            this.GetDepartmentDocumentDetails(this.itemsPerPage, pageNo,this.dep_Id);
        }
    
    
      //Search item
    
    
      onSearch(dep_Id,s,itemsPerPage: number, pageNo: number) {  
        debugger; 
        this.isSearch = true;
        let searchText = this.s.SearchText;
        let searchCriteria = this.s.SearchCriteria;
        if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
          swal("Warning!", "Please enter the search criteria and search text.", "warning");
        else {
          document.getElementById('loader-spinner').style.display = "block";
          this.userService.GetDepartmentDocumentOnSearch(this.dep_Id,searchCriteria, searchText, itemsPerPage,pageNo)
            .subscribe(
              (data: any) => {
                if(data.DepartmentDocumentModel.length!=0){              
                this.DepartmentDocumentdetails = data.DepartmentDocumentModel;
                this.totalItems = data.TotalItemsCount;
                this.currentPage = pageNo;
                document.getElementById('loader-spinner').style.display = "none";
              }
              else
              {
              document.getElementById('loader-spinner').style.display = "none";         
              }
              }, (error) => {
                document.getElementById('loader-spinner').style.display = "none";
                if (error.status == 401|| error.status == 500) {
                  this.errorHandler.handleError(error);
                }
                else if (error.status == 400) {
                  swal('Warning!', error.error.Message, 'warning');
                }
              });
        }
      }
      Delete(DeptDoc_Id){
        debugger;
       
        swal({
             title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.value) {
            this.data = this.userService.DeleteDepartmentDocumentById(DeptDoc_Id);
            this.data.subscribe(
             (response: any) => {
                 this. GetDepartmentDocumentDetails(this.itemsPerPage, 1,this.dep_Id)          
             },(error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            }       
          ); 
        } 
        })
        }
    
    
    }
    



// WEBPACK FOOTER //
// ./src/app/masters/dept-document/dept-document-form/dept-document-form.component.ts